import ReactDOM from 'react-dom';
import React from 'react';

global.OTUReact = {
		renderView(viewName,props,container,callback) {
			import(`../myjsx/views/${viewName}`).then((view)=> {
				  console.log(`React - View ${viewName} loaded`);
				  const element=React.createElement(view.default, props, null);



				  ReactDOM.render(element, container, function (e) {
						// if the container is part of a template we add it to this containers data as a propery with jquery
						// when we reload the template position we will unmount the component.
						var template = jQuery(container).closest("[data-template-position]");
						if (template.length) {
							console.log(`React - View ${viewName} storing container in template`)
							var nodes = jQuery(template[0]).data('reactNodes');
							if (!Array.isArray(nodes)) nodes = [];
							nodes.push(container);
							jQuery(template[0]).data('reactNodes',nodes);
						}

						if (typeof callback=='function') callback();
				  });
			});

		},
		unmountContainer(container) {
			if (ReactDOM.unmountComponentAtNode(container)) {
				console.log('React - Unmounted Component');
			} else {
				console.log('React - Unmount failed, no component found for container');
			};
		}
}
